import React from 'react'
import PropTypes from 'prop-types'

import { Flex } from '../elements'
import { Caption, CTA } from '../typography'
import styled from 'styled-components'

const CaptionContainer = styled(Caption)`

  font-style: normal;
  font-weight: 500;
  line-height: 135%; /* 21.6px */
  letter-spacing: 0.8px;

  @media all and (max-width: 1024px) {
    padding-bottom: null;
  }

  @media all and (max-width: 1023px) {
    padding-bottom: 8px;
  }
`

const ParagraphContainer = styled(CTA)`
  padding-bottom: 6px;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 125% */
  letter-spacing: -0.96px;
  text-transform: uppercase;

  @media all and (max-width: 1024px) {
    padding-bottom: null;
  }

  @media all and (max-width: 1023px) {
    padding-bottom: 9px;
    font-size: 24px;
    line-height: 135%; /* 32.4px */
    letter-spacing: -0.72px;
  }
`

const SentenceContainer = styled(CTA)`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 133.333% */
  letter-spacing: 0.396px;
  text-transform: unset;
  margin-bottom: ${(props) => (props.$signUpPage ? '16px' : '60px')};

  @media all and (max-width: 1024px) {
    font-size: 14px;
    text-transform: inherit;
  }

  @media all and (max-width: 1023px) {
    font-size: 16px;
    text-transform: inherit;
  }

  @media all and (max-width: 640px) {
    margin-bottom: 5px;
    font-size: 15px;
    text-transform: inherit;
  }
`

const FlexContainer = styled(Flex)`
  align-items: start;
  flex-direction: column;
  text-align: start;
`

const StepHeader = ({ body, step, title, ...rest }) => (
  <FlexContainer {...rest}>
    {step && (
      <CaptionContainer id='stepHeader_caption'>{step}</CaptionContainer>
    )}
    {title && (
      <ParagraphContainer id='stepHeader_title'>{title}</ParagraphContainer>
    )}
    {body && rest.isSignUpPage && (
      <SentenceContainer $signUpPage id='stepHeader_body'>
        {body} 
      </SentenceContainer>
    )}
    {body && !rest.isSignUpPage && (
      <SentenceContainer id='stepHeader_body'>{body}</SentenceContainer>
    )}
  </FlexContainer>
)

StepHeader.propTypes = {
  body: PropTypes.node,
  step: PropTypes.node,
  title: PropTypes.node
}

export default StepHeader
